import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sentry } from "@/lib/sentry";

export const Route = createFileRoute("/sentry-test")({
  head: () => ({
    meta: [
      { title: "Sentry Test — Inkubera" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: SentryTestPage,
});

function SentryTestPage() {
  const [eventId, setEventId] = useState<string | null>(null);

  const throwRenderError = () => {
    throw new Error(
      `Sentry sourcemap test (render) — ${new Date().toISOString()}`,
    );
  };

  const captureManualError = () => {
    const id = Sentry.captureException(
      new Error(
        `Sentry sourcemap test (manual) — ${new Date().toISOString()}`,
      ),
    );
    setEventId(id);
  };

  const captureMessage = () => {
    const id = Sentry.captureMessage(
      `Sentry sourcemap test (message) — ${new Date().toISOString()}`,
      "info",
    );
    setEventId(id);
  };

  const [shouldThrow, setShouldThrow] = useState(false);
  if (shouldThrow) throwRenderError();

  return (
    <div className="mx-auto max-w-xl p-8 space-y-6">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Sentry test</h1>
        <p className="text-sm text-muted-foreground">
          Använd den här sidan för att verifiera att sourcemaps är korrekt
          uppladdade och kopplade till rätt release i Sentry.
        </p>
      </div>

      <div className="space-y-3">
        <Button onClick={captureManualError} variant="outline">
          Skicka fel via Sentry.captureException
        </Button>
        <Button onClick={captureMessage} variant="secondary">
          Skicka meddelande via Sentry.captureMessage
        </Button>
        <Button onClick={() => setShouldThrow(true)} variant="destructive">
          Kasta render-fel (kraschar sidan)
        </Button>
      </div>

      {eventId && (
        <div className="rounded-md border p-4 text-sm">
          <div className="font-medium">Event skickat</div>
          <code className="text-xs break-all">{eventId}</code>
          <p className="mt-2 text-muted-foreground">
            Öppna Sentry → Issues och kontrollera att stacktrace pekar på{" "}
            <code>src/routes/sentry-test.tsx</code> (inte minifierad fil), och
            att eventet är taggat med rätt <code>release</code>.
          </p>
        </div>
      )}
    </div>
  );
}
